import React,{ Component } from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import FieldGroup from '../../../../components/FieldGroup';

class Filters extends Component {
    constructor(props) {
        super(props);

        this.state = {
            day: '',
        };

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
    }

    handleFieldChange(event) {
        const { value,name } = event.target;

        this.setState({
            [name]: value
        });
    }

    handleFormSubmit(e) {
        e.preventDefault();

        this.props.onSubmit(this.state);
    }

    render() {
        return (
            <form onSubmit={this.handleFormSubmit}>
                <Row>
                    <Col lg={12}>
                        <FieldGroup
                            type="date"
                            name="day"
                            label="Date:"
                            onChange={this.handleFieldChange}
                            value={this.state.day}
                            required
                        />
                    </Col>
                </Row>

                <Button type="submit" bsStyle="info" className="m-b-15" >Apply</Button>
            </form>
        );
    }
}

export default Filters;


// WEBPACK FOOTER //
// ./src/scenes/PushapiCpc/components/Form/index.js